import { Directive, ElementRef, Inject, Input, NgZone, Optional } from "@angular/core";
import { ANIMATION_MODULE_TYPE } from "@angular/platform-browser/animations";

import { ɵNzTabsInkBarDirective } from "ng-zorro-antd/tabs";
import { UiTabPositionMode } from "../models/tab.models";

@Directive({
  selector: "ui-tabs-ink-bar, [ui-tabs-ink-bar]",
})
export class UiTabsInkBarDirective extends ɵNzTabsInkBarDirective {
  @Input() public position: UiTabPositionMode = "horizontal";
  @Input() public animated = true;

  constructor(elementRef: ElementRef<HTMLElement>, ngZone: NgZone, @Optional() @Inject(ANIMATION_MODULE_TYPE) public animationMode?: string) {
    super(elementRef, ngZone, animationMode);
  }
}
